/* eslint-disable */
import { ifMobile, isTablet } from "./chc/helpers";

document.addEventListener("alpine:init", () => {

    Alpine.data("background", (props) => {
        return {
            ...props,
            deviceType: "desktop",
            setBg(desktopImg, mobileImg, tabletImg) {
                if (isTablet() && tabletImg) {
                    this.$el.style.backgroundImage = `url('${tabletImg || "#"}')`;
                    return;
                }

                this.$el.style.backgroundImage = ifMobile() ? `url('${mobileImg || "#"}')` : `url('${desktopImg || "#"}')`;
            },
            setBackgroundImage(desktopImg, mobileImg, tabletImg) {
                let timeout;
                this.setBg(desktopImg, mobileImg, tabletImg);

                if (desktopImg === mobileImg) return;

                window.addEventListener("resize", () => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => this.setBg(desktopImg, mobileImg, tabletImg), 100);
                });
            }, 
            deviceSwitch() {
                this.deviceType = this.deviceCondition;

                window.addEventListener("resize", () => {
                    this.$nextTick(() => this.deviceType = this.deviceCondition);
                });
            },
            get deviceCondition() {
                const deviceType = ifMobile() ? "mobile" : "desktop";
                return deviceType;
            }
        }
    });

});